import React, { useEffect, useCallback, useRef } from "react";
import { useUBO } from "../../../hooks/useUBO";
import { UBOForm } from "../../forms/ubo/uboForm";

export const CorporateUBOForm = React.memo(({ renderBy, index, initialData, onUpdate, isReadOnly, isReport }) => {
    // Initialize hook with parent's data
    const [uboState, updateUBO, setUBOState] = useUBO(initialData);
    const isInitialMount = useRef(true);

    // Same as the corporate-structure form: a parent-side replacement (refetch after
    // save) must win over the copy seeded on mount, or stale local state gets pushed
    // back up over saved answers.
    useEffect(() => {
      if (initialData && JSON.stringify(initialData) !== JSON.stringify(uboState)) {
        setUBOState(initialData);
      }
      // uboState is deliberately not a dependency: this only reacts to parent-side changes.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialData, setUBOState]);

    const stableUpdate = useCallback(() => {
        if (JSON.stringify(initialData) !== JSON.stringify(uboState)) {
          onUpdate(uboState);
        }
      }, [initialData, onUpdate, uboState]); // Only update when uboState changes

    // Notify parent of changes
    useEffect(() => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }
        stableUpdate();
      }, [stableUpdate]);
  
    return (
      <UBOForm
        renderBy={renderBy}
        index={index}
        isReport={isReport}
        isReadOnly={isReadOnly}
        uboType={uboState.type}
        uboPercentage={uboState.percentage}
        uboData={uboState.data}
        onUBOChange={updateUBO}
      />
    );
  });